/**
 * Een logo kiezen: PNG, JPEG of WebP, hooguit 1 MB. Het bestand gaat als
 * base64 mee in het JSON van het formulier; de Worker controleert de bytes.
 */

import { useState } from 'react';
import type { Logo } from '../lib/vormen';

const TYPEN = ['image/png', 'image/jpeg', 'image/webp'];

export function Logokiezer({ logo, huidigeUrl, onChange }: { logo: Logo | null; huidigeUrl?: string | null; onChange: (logo: Logo | null) => void }) {
  const [fout, zetFout] = useState<string | null>(null);

  async function kies(bestand: File | undefined) {
    zetFout(null);
    if (!bestand) return;
    if (!TYPEN.includes(bestand.type)) {
      zetFout('Kies een PNG, JPEG of WebP.');
      return;
    }
    if (bestand.size > 1_000_000) {
      zetFout('Het logo is groter dan 1 MB. Verklein het eerst.');
      return;
    }
    const data = await new Promise<string>((klaar, weiger) => {
      const lezer = new FileReader();
      lezer.onload = () => klaar(String(lezer.result).replace(/^data:[^,]*,/, ''));
      lezer.onerror = () => weiger(new Error('Lezen mislukt'));
      lezer.readAsDataURL(bestand);
    });
    onChange({ type: bestand.type, data });
  }

  const voorvertoning = logo ? `data:${logo.type};base64,${logo.data}` : huidigeUrl ?? null;

  return (
    <div>
      <span className="etiket">Logo (niet verplicht)</span>
      <div className="flex flex-wrap items-center gap-4">
        {voorvertoning && (
          <span className="flex h-16 w-24 items-center justify-center rounded-lg bg-white p-1">
            <img src={voorvertoning} alt="" className="max-h-full max-w-full object-contain" />
          </span>
        )}
        <label className="knop knop-stil knop-klein cursor-pointer">
          {voorvertoning ? 'Ander logo kiezen' : 'Logo kiezen'}
          <input type="file" accept={TYPEN.join(',')} className="sr-only" onChange={(e) => kies(e.target.files?.[0])} />
        </label>
        {(logo || huidigeUrl) && (
          <button type="button" className="text-sm text-inkt-zacht hover:text-rood" onClick={() => onChange(null)}>
            Verwijderen
          </button>
        )}
      </div>
      <span className="mt-1.5 block text-sm text-inkt-zacht">PNG, JPEG of WebP, hooguit 1 MB. Komt op een wit vlak te staan.</span>
      {fout && <span className="mt-1 block text-sm text-rood">{fout}</span>}
    </div>
  );
}
